import type { Color } from '@blocksuite/affine-model';
import type { GfxCompatibleProps } from '@blocksuite/std/gfx';
import { GfxCompatible } from '@blocksuite/std/gfx';
import {
  BlockModel,
  BlockSchemaExtension,
  defineBlockSchema,
} from '@blocksuite/store';

export const BRUSH_HEADING_COLORS = [
  'beige',
  'green',
  'turquoise',
  'red',
] as const;

export type BrushHeadingPresetColor = (typeof BRUSH_HEADING_COLORS)[number];

export type BrushHeadingBlockProps = {
  text: string;
  color: Color;
  /** Empty string keeps automatic contrast against the brush color. */
  textColor: Color;
  fontSize: number;
  /** Persisted painted-edge variant. */
  brushVariant: number;
  rotate: number;
} & GfxCompatibleProps;

export class BrushHeadingBlockModel extends GfxCompatible<BrushHeadingBlockProps>(
  BlockModel
) {}

export const BrushHeadingBlockSchema = defineBlockSchema({
  flavour: 'affine:brush-heading',
  props: (): BrushHeadingBlockProps => ({
    text: '',
    color: 'beige',
    textColor: '',
    fontSize: 21,
    brushVariant: 0,
    rotate: 0,
    xywh: '[0,0,420,86]',
    index: 'a0',
    lockedBySelf: false,
  }),
  metadata: {
    role: 'content',
    version: 1,
    parent: ['@root', 'affine:surface'],
    children: [],
  },
  toModel: () => new BrushHeadingBlockModel(),
});

export const BrushHeadingBlockSchemaExtension = BlockSchemaExtension(
  BrushHeadingBlockSchema
);
